/* ab-r-series-product-selections.js
USED BY: ab-r-series-options.liquid

PURPOSE: shows additional r series selections and options to create a variation of the product.

NOTE: product part number is set in the ab-r-series-options.liquid file and used here in js
productPartNum - mfg part #
*/

// set default values for polarization, options, and wire codes.  NOTE: Wire codes are only applicable to RA products in the R Series
let pValue = "00";
let oValue = "";
let wcValue = "";
let newPartNumName = "";

// store all (2 & 3 row) keying images in a array so we can grab the value by code value (ex. R07 in polarization section)
let polarImgArray = {
    R01: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R01.png?v=1723854438",
    R02: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R02.png?v=1723854438",
    R03: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R03.png?v=1723854438",
    R04: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R04.png?v=1723854438",
    R05: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R05.png?v=1723854438",
    R06: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R06.png?v=1723854439",
    R07: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R07.png?v=1723854439",
    R08: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R08.png?v=1723854439",
    R09: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R09.png?v=1723854438",
    R10: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R10.png?v=1723854438",
    R11: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R11.png?v=1723854439",
    R12: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R12.png?v=1723854438",
    R13: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R13.png?v=1723854438",
    R14: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R14.png?v=1723854438",
    R15: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R15.png?v=1723854438",
    R16: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R16.png?v=1723854439",
    R17: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R17.png?v=1723854438",
    R18: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R18.png?v=1723854438",
    R19: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R19.png?v=1723854438",
    R20: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R20.png?v=1723854438",
    R21: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R21.png?v=1723854438",
    R22: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R22.png?v=1723854439",
    R23: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R23.png?v=1723854438",
    R24: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R24.png?v=1723854439",
    R25: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R25.png?v=1723854438",
    R26: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R26.png?v=1723854438",
    R27: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R27.png?v=1723854439",
    R28: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R28.png?v=1723854438",
    R29: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R29.png?v=1723854438",
    R30: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R30.png?v=1723854438",
    R31: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R31.png?v=1723854438",
    R32: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R32.png?v=1723854438",
    R33: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R33.png?v=1723854438",
    R34: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R34.png?v=1723854438",
    R35: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R35.png?v=1723854438",
    R36: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R36.png?v=1723854438",
    R37: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R37.png?v=1723854438",
    R38: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R38.png?v=1723854439",
    R39: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R39.png?v=1723854438",
    R40: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R40.png?v=1723854438",
    R41: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R41.png?v=1723854438",
    R42: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R42.png?v=1723854438",
    R43: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R43.png?v=1723854439",
    R44: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R44.png?v=1723854438",
    R45: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R45.png?v=1723854438",
    R46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R46.png?v=1723854439",
    R47: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R47.png?v=1723854438",
    R48: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R48.png?v=1723854438",
    R49: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R49.png?v=1723854438",
    R50: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R50.png?v=1723854438",
    R51: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R51.png?v=1723854438",
    R52: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R52.png?v=1723854438",
    R53: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R53.png?v=1723854438",
    R54: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R54.png?v=1723854439",
    R55: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R55.png?v=1723854438",
    R56: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R56.png?v=1723854438",
    R57: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R57.png?v=1723854439",
    R58: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R58.png?v=1723854438",
    R59: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R59.png?v=1723854438",
    R60: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R60.png?v=1723854438",
    R61: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R61.png?v=1723854439",
    R62: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R62.png?v=1723854439",
    R63: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R63.png?v=1723854438",
    R64: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R64.png?v=1723854438",
    R65: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R65.png?v=1723854438",
    R66: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R66.png?v=1723854438",
    R67: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R67.png?v=1723854438",
    R68: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R68.png?v=1723854438",
    R70: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R70.png?v=1723854438",


    // store 4 & 6 row polarization images
    R01_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R01-46.png?v=1744833308",
    R02_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R02-46.png?v=1744833308",
    R03_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R03-46.png?v=1744833308",
    R04_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R04-46.png?v=1744833307",
    R05_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R05-46.png?v=1744833307",
    R06_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R06-46.png?v=1744833307",
    R07_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R07-46.png?v=1744833307",
    R08_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R08-46.png?v=1744833308",
    R09_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R09-46.png?v=1744833308",
    R10_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R10-46.png?v=1744833308",
    R11_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R11-46.png?v=1744833308",
    R12_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R12-46.png?v=1744833308",
    R13_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R13-46.png?v=1744833308",
    R14_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R14-46.png?v=1744833308",
    R15_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R15-46.png?v=1744833308",
    R16_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R16-46.png?v=1744833308",
    R17_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R17-46.png?v=1744833308",
    R18_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R18-46.png?v=1744833308",
    R19_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R19-46.png?v=1744833308",
    R20_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R20-46.png?v=1744833308",
    R21_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R21-46.png?v=1744833308",
    R22_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R22-46.png?v=1744833308",
    R23_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R23-46.png?v=1744833308",
    R24_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R24-46.png?v=1744833308",
    R25_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R25-46.png?v=1744833308",
    R26_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R26-46.png?v=1744833308",
    R27_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R27-46.png?v=1744833308",
    R28_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R28-46.png?v=1744833308",
    R29_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R29-46.png?v=1744833308",
    R30_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R30-46.png?v=1744833308",
    R31_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R31-46.png?v=1744833308",
    R32_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R32-46.png?v=1744833308",
    R33_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R33-46.png?v=1744833308",
    R34_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R34-46.png?v=1744833308",
    R35_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R35-46.png?v=1744833308",
    R36_46: "https://cdn.shopify.com/s/files/1/0707/6321/7110/files/R36-46.png?v=1744833308",
};

// Hardware Style(s) that allow for polarization: 55 (2 & 3 row), 95, 96, 97 (4 row)
if (productHardwareType == '55' || productHardwareType == '95' || productHardwareType == '96' || productHardwareType == '97') {
    const hwPolarSelector = document.querySelector('#polarization');
    const hwPolarContainer = document.querySelector('#hwPolarImg');

    // add event listener for polarization selection
    hwPolarSelector.addEventListener('change', function () {

        if (hwPolarSelector.value != "") {
            pValue = hwPolarSelector.value;
            let keyPosName = "";
            if (productHardwareType == '55') {
                keyPosName = "R" + pValue.slice(-2);
            } else {
                keyPosName = "R" + pValue.slice(-2) + "_46";
            }
            if (hwPolarSelector.value == "00") {
                hwPolarContainer.innerHTML = '';
            } else {
                hwPolarContainer.innerHTML = '<img class="hw-options-image" src=' + polarImgArray[keyPosName] + ' alt="' + keyPosName + '" />';
            }
        } else {
            hwPolarContainer.innerHTML = '';
        };
        updateVariantName();
    });
}



const optionSelector = document.querySelector('#options');

// add event listener for options selection (if options exist for this part number (ie not null))
if (optionSelector != null) {
    optionSelector.addEventListener('change', function () {
        oValue = optionSelector.value;
        updateVariantName();
    });
}




// update variant name based on options that are selected
function updateVariantName() {
    newPartNumName = productPartNum;
    // add polarization to the part number 
    // change: RM252-100-312-5500 to RM252-100-312-5538 (RM252-100-312-55 + 38)
    newPartNumName = productPartNum.slice(0, productPartNum.length - 2) + pValue;

    // add options to the part number
    // change: RM252-100-312-5500 to RM252-100-312-5500-BN
    if (oValue != "") {
        newPartNumName = newPartNumName + "-" + oValue;
    }

    // add wire codes to the part number (RA3D2-104-3AA-5500 -> RA3D2-104-3CD-5500)
    // get the part number up to the wire code
    if (wireCode != "--") {
      let wireCodePartNumPrefix = newPartNumName.slice(0, 11);
      let wireCodePartNumSuffix = newPartNumName.slice(13);
      newPartNumName = wireCodePartNumPrefix + wireCode + wireCodePartNumSuffix;
    }
    
    /*
        const variantNameContainer = document.querySelector('#variant-name');
        if (wireCode != 'AA' && wireCode != 'BLANK' && wireCode != '') {
            variantNameContainer.innerHTML = '<div>Selected wire code: ' + wireCode + '</div><div><h6> <div class="variant-name" id="variant-name"></div>Variant Part #: ' + newPartNumName + '</h6> (' + productPartNum + ') </div>';
            const variantName = document.querySelector('#variant-part-num');
            variantName.value = newPartNumName;
    
        }
    */

    const variantNameContainer = document.querySelector('#variant-name');
    if (newPartNumName != productPartNum) {
        variantNameContainer.innerHTML = '<div><h6> <div class="variant-name" id="variant-name"></div>Variant Part #: ' + newPartNumName + '</h6> (' + productPartNum + ') </div>';
        const variantName = document.querySelector('#variant-part-num');
        variantName.value = newPartNumName;
    } else {
        variantNameContainer.innerHTML = '';
    }
}

/* WIRE SELECTIONS */
/*NOTE: product part number is set in the ab-r-series-options.liquid file and used here in js
productPartNum - mfg part #
*/

let wireCode = "--";
let wireSizeCheck = "";
let wireSpecCheck = "";

const typeSelector = document.querySelector('#select-code');
const wireCodeSelector = document.querySelector('#wire-code-selection');
const wireCodeSelectorGroup = document.querySelector('#wire-code-group');
wireCodeSelectorGroup.hidden = true;
const wireSpecSelector = document.querySelector('#wire-spec');
const wireSpecSelectorGroup = document.querySelector('#wire-spec-group');
wireSpecSelectorGroup.hidden = true;
const wireSizeSelector = document.querySelector('#wire-size');
const wireSizeSelectorGroup = document.querySelector('#wire-size-group');
wireSizeSelectorGroup.hidden = true;
const wireColorSelector = document.querySelector('#wire-color');
const wireColorSelectorGroup = document.querySelector('#wire-color-group');
wireColorSelectorGroup.hidden = true;
const wireLengthSelector = document.querySelector('#wire-length');
const wireLengthSelectorGroup = document.querySelector('#wire-length-group');
wireLengthSelectorGroup.hidden = true;

// check that wire codes exist for this part number
if (typeSelector != null) {
    // add event listener for wire code input selector selection
    typeSelector.addEventListener('change', function () {
        //reset the wire code value
        wireCode = '--';

        // if user knows their desired wire code, let them select it
        if (typeSelector.value == 'YES') {
            wireCodeSelectorGroup.hidden = false;
            wireSpecSelectorGroup.hidden = true;
            wireSizeSelectorGroup.hidden = true;
            wireColorSelectorGroup.hidden = true;
            wireLengthSelectorGroup.hidden = true;
            // otherwise, help user select building blocks to make the wire code
        } else if (typeSelector.value == 'NO') {
            wireCodeSelector.value = getWireCode();
            updateVariantName();
            // hide the wire codes list
            wireCodeSelectorGroup.hidden = true;
            // show the specification selector
            wireSpecSelectorGroup.hidden = false;
        }
    });

    // add event listener for wire code input selector selection
    wireCodeSelector.addEventListener('change', function () {
        if (typeSelector.value == 'YES') {
            wireCode = wireCodeSelector.value;
            setWireFields(wireCode);
            updateVariantName();
        }
    })


    // add event listener for wire spec input selector selection
    wireSpecSelector.addEventListener('change', function () {
        if (wireSpecSelector.value == 'BLANK') {
            wireSizeSelectorGroup.hidden = true;
            wireColorSelectorGroup.hidden = true;
            wireLengthSelectorGroup.hidden = true;
        } else {
            wireSizeSelectorGroup.hidden = false;
            wireColorSelectorGroup.hidden = true;
            wireLengthSelectorGroup.hidden = true;
        }
        // updated wire size & color menus based on spec slection
        updateWireSizeMenu();
        updateWireColorMenu();
        wireCode = getWireCode(wireSpecSelector.value, wireSizeSelector.value, wireColorSelector.value, wireLengthSelector.value);
        updateVariantName();
    })

    // add event listener for wire size input selector selection
    wireSizeSelector.addEventListener('change', function () {
        if (wireSizeSelector.value == 'BLANK') {
            wireColorSelectorGroup.hidden = true;
            wireLengthSelectorGroup.hidden = true;
        } else {
            wireColorSelectorGroup.hidden = false;
            wireLengthSelectorGroup.hidden = true;
        }
        wireCode = getWireCode(wireSpecSelector.value, wireSizeSelector.value, wireColorSelector.value, wireLengthSelector.value);
        updateVariantName();
    })

    // add event listener for wire color input selector selection
    wireColorSelector.addEventListener('change', function () {
        if (wireColorSelector.value == 'BLANK') {
            wireLengthSelectorGroup.hidden = true;
        } else {
            wireLengthSelectorGroup.hidden = false;
        }
        wireCode = getWireCode(wireSpecSelector.value, wireSizeSelector.value, wireColorSelector.value, wireLengthSelector.value);
        // set the wire code list value to match the new wire code.  This shows it nicely when adding to the cart.
        wireCodeSelector.value = wireCode;
        updateVariantName();
    })

    // add event listener for wire length input selector selection
    wireLengthSelector.addEventListener('change', function () {
        if (wireLengthSelector.value != 'BLANK') {
            wireCode = getWireCode(wireSpecSelector.value, wireSizeSelector.value, wireColorSelector.value, wireLengthSelector.value);
            updateVariantName();
        }

    })

    function updateWireSizeMenu() {
        wireSizeSelector.innerHTML = '<option value="BLANK"> --Please choose a wire size-- </option><option value="22"> 22 AWG</option><option value="24"> 24 AWG</option><option value="26"> 26 AWG</option><option value="28"> 28 AWG</option><option value="30"> 30 AWG</option>';
    }

    function updateWireColorMenu() {
        wireColorSelector.innerHTML = '<option value="BLANK"> --Please choose a color-- </option><option value="COLOR"> Ten colors repeating</option><option value="WHITE"> White</option>';
    }


    // set the wire code value when user is building up the wire code using color, spec, size, and length inputs
    function getWireCode(wcSpec, wcSize, wcColor, wcLength) {
        if (wcSpec != 'BLANK' && wcSize != 'BLANK' && wcColor != 'BLANK' && wcLength != 'BLANK') {
            let wcColorCheck = "";
            let wcSpecCheck = "";
            let wcSizeCheck = "";
            let wcLengthCheck = "";


            for (const eachGroup in wcDictionary) {
                let wcSpecCheck = wcDictionary[eachGroup]["wcSpecMenu"];
                let wcSizeCheck = wcDictionary[eachGroup]["wcWireSizeMenu"];
                let wcColorCheck = wcDictionary[eachGroup]["wcColorMenu"];
                let wcLengthCheck = wcDictionary[eachGroup]["wcLengthMenu"];
                //console.log(wcSpecCheck + ", " + wcSizeCheck + ", " + wcColorCheck + ", " + wcLengthCheck);

                if (wcSpecCheck == wcSpec && wcSizeCheck == wcSize && wcColorCheck == wcColor && wcLengthCheck == wcLength) {
                    console.log("*****  MATCH FOUND  ******  CODE: " + wcDictionary[eachGroup]["wireCode"]);
                    wireCodeSelector.value = wcDictionary[eachGroup]["wireCode"];
                    return wcDictionary[eachGroup]["wireCode"];
                }
            }
        } else {
            return 'BLANK';
        }
    }

    // set the values for color, spec, size, and length inputs when user is directly selecting the wire code input 
    function setWireFields(wireCode) {
        if (wireCode != 'BLANK') {
            let wireCodeCheck = "";
            let wcColor = "";
            let wcSpec = "";
            let wcSize = "";
            let wcLength = "";


            for (const eachGroup in wcDictionary) {
                let wireCodeCheck = wcDictionary[eachGroup]["wireCode"];
                if (wireCodeCheck == wireCode) {
                    console.log("*****  MATCH FOUND  ******  CODE: " + wcDictionary[eachGroup]["wireCode"]);
                    wireCodeSelector.value = wcDictionary[eachGroup]["wireCode"];
                    wcSpec = wcDictionary[eachGroup]["wcSpecMenu"];
                    wcSize = wcDictionary[eachGroup]["wcWireSizeMenu"];
                    wcColor = wcDictionary[eachGroup]["wcColorMenu"];
                    wcLength = wcDictionary[eachGroup]["wcLengthMenu"];

                  wireSpecSelector.value = wcSpec;
                  wireSizeSelector.value = wcSize;
                  wireColorSelector.value = wcColor;
                  wireLengthSelector.value = wcLength;                  
                  return wcDictionary[eachGroup]["wireCode"];
                }
            }
        } else {
            return 'BLANK';
        }
    }

    const wcDictionary = {

        "AA": {
            "wireCode": "AA",
            "wcDesc": "22 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 6\"",
            "wcMenuDesc": "AA (Size: 22AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 6.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "6.0\"",
            "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "6"
        },
        "AB": {
            "wireCode": "AB",
            "wcDesc": "22 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 12\"",
            "wcMenuDesc": "AB (Size: 22AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 12.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "12.0\"",
            "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "12"
        },
        "AC": {
            "wireCode": "AC",
            "wcDesc": "22 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 18\"",
            "wcMenuDesc": "AC (Size: 22AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 18.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "18.0\"",
            "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "18"
        },
        "AD": {
            "wireCode": "AD",
            "wcDesc": "22 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 24\"",
            "wcMenuDesc": "AD (Size: 22AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 24.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "cWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "24.0\"",
            "wcLengthDesc": "24.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "24"
        },
        "AE": {
            "wireCode": "AE",
            "wcDesc": "22 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 30\"",
            "wcMenuDesc": "AE (Size: 22AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 30.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "30.0\"",
            "wcLengthDesc": "30.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "30"
        },
        "AF": {
            "wireCode": "AF",
            "wcDesc": "22 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 36\"",
            "wcMenuDesc": "AF (Size: 22AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 36.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "36.0\"",
            "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "36"
        },
        "AG": {
            "wireCode": "AG",
            "wcDesc": "22 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 42\"",
            "wcMenuDesc": "AG (Size: 22AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 42.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "42.0\"",
            "wcLengthDesc": "42.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "42"
        },
        "AH": {
            "wireCode": "AH",
            "wcDesc": "22 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 48\"",
            "wcMenuDesc": "AH (Size: 22AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 48.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "48.0\"",
            "wcLengthDesc": "48.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "48"
        },
        "AJ": {
            "wireCode": "AJ",
            "wcDesc": "22 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 54\"",
            "wcMenuDesc": "AJ (Size: 22AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 54.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "54.0\"",
            "wcLengthDesc": "54.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "54"
        },
        "AK": {
            "wireCode": "AK",
            "wcDesc": "22 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 60\"",
            "wcMenuDesc": "AK (Size: 22AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 60.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "60.0\"",
            "wcLengthDesc": "60.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "60"
        },
        "AL": {
            "wireCode": "AL",
            "wcDesc": "22 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 66\"",
            "wcMenuDesc": "AL (Size: 22AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 66.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "66.0\"",
            "wcLengthDesc": "66.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "66"
        },
        "AM": {
            "wireCode": "AM",
            "wcDesc": "22 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 72\"",
            "wcMenuDesc": "AM (Size: 22AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 72.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "72.0\"",
            "wcLengthDesc": "72.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "72"
        },
        "AN": {
            "wireCode": "AN",
            "wcDesc": "22 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 84\"",
            "wcMenuDesc": "AN (Size: 22AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 84.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "84.0\"",
            "wcLengthDesc": "84.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "84"
        },
        "AP": {
            "wireCode": "AP",
            "wcDesc": "22 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 96\"",
            "wcMenuDesc": "AP (Size: 22AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 96.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "NMIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "96.0\"",
            "wcLengthDesc": "96.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "96"
        },
        "AR": {
            "wireCode": "AR",
            "wcDesc": "22 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 108\"",
            "wcMenuDesc": "AR (Size: 22AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 108.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "108.0\"",
            "wcLengthDesc": "108.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "108"
        },
        "AS": {
            "wireCode": "AS",
            "wcDesc": "22 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 120\"",
            "wcMenuDesc": "AS (Size: 22AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 120.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "120.0\"",
            "wcLengthDesc": "120.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "120"
        },

        "BA": {
            "wireCode": "BA",
            "wcDesc": "22 AWG, MIL-W-16878/4, White, Length: 6\"",
            "wcMenuDesc": "BA (Size: 22AWG, Spec: MIL-W-16878/4, Color: White, Length: 6.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "6.0\"",
            "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "6"
        },
        "BB": {
            "wireCode": "BB",
            "wcDesc": "22 AWG, MIL-W-16878/4, White, Length: 12\"",
            "wcMenuDesc": "BB (Size: 22AWG, Spec: MIL-W-16878/4, Color: White, Length: 12.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "12.0\"",
            "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "12"
        },
        "BC": {
            "wireCode": "BC",
            "wcDesc": "22 AWG, MIL-W-16878/4, White, Length: 18\"",
            "wcMenuDesc": "BC (Size: 22AWG, Spec: MIL-W-16878/4, Color: White, Length: 18.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "18.0\"",
            "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "18"
        },
        "BD": {
            "wireCode": "BD",
            "wcDesc": "22 AWG, MIL-W-16878/4, White, Length: 24\"",
            "wcMenuDesc": "BD (Size: 22AWG, Spec: MIL-W-16878/4, Color: White, Length: 24.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "cWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "24.0\"",
            "wcLengthDesc": "24.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "24"
        },
        "BE": {
            "wireCode": "BE",
            "wcDesc": "22 AWG, MIL-W-16878/4, White, Length: 30\"",
            "wcMenuDesc": "BE (Size: 22AWG, Spec: MIL-W-16878/4, Color: White, Length: 30.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "30.0\"",
            "wcLengthDesc": "30.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "30"
        },
        "BF": {
            "wireCode": "BF",
            "wcDesc": "22 AWG, MIL-W-16878/4, White, Length: 36\"",
            "wcMenuDesc": "BF (Size: 22AWG, Spec: MIL-W-16878/4, Color: White, Length: 36.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "36.0\"",
            "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "36"
        },
        "BG": {
            "wireCode": "BG",
            "wcDesc": "22 AWG, MIL-W-16878/4, White, Length: 42\"",
            "wcMenuDesc": "BG (Size: 22AWG, Spec: MIL-W-16878/4, Color: White, Length: 42.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "42.0\"",
            "wcLengthDesc": "42.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "42"
        },
        "BH": {
            "wireCode": "BH",
            "wcDesc": "22 AWG, MIL-W-16878/4, White, Length: 48\"",
            "wcMenuDesc": "BH (Size: 22AWG, Spec: MIL-W-16878/4, Color: White, Length: 48.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "48.0\"",
            "wcLengthDesc": "48.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "48"
        },
        "BJ": {
            "wireCode": "BJ",
            "wcDesc": "22 AWG, MIL-W-16878/4, White, Length: 54\"",
            "wcMenuDesc": "BJ (Size: 22AWG, Spec: MIL-W-16878/4, Color: White, Length: 54.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "54.0\"",
            "wcLengthDesc": "54.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "54"
        },
        "BK": {
            "wireCode": "BK",
            "wcDesc": "22 AWG, MIL-W-16878/4, White, Length: 60\"",
            "wcMenuDesc": "BK (Size: 22AWG, Spec: MIL-W-16878/4, Color: White, Length: 60.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "60.0\"",
            "wcLengthDesc": "60.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "60"
        },
        "BL": {
            "wireCode": "BL",
            "wcDesc": "22 AWG, MIL-W-16878/4, White, Length: 66\"",
            "wcMenuDesc": "BL (Size: 22AWG, Spec: MIL-W-16878/4, Color: White, Length: 66.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "66.0\"",
            "wcLengthDesc": "66.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "66"
        },
        "BM": {
            "wireCode": "BM",
            "wcDesc": "22 AWG, MIL-W-16878/4, White, Length: 72\"",
            "wcMenuDesc": "BM (Size: 22AWG, Spec: MIL-W-16878/4, Color: White, Length: 72.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "72.0\"",
            "wcLengthDesc": "72.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "72"
        },
        "BN": {
            "wireCode": "BN",
            "wcDesc": "22 AWG, MIL-W-16878/4, White, Length: 84\"",
            "wcMenuDesc": "BN (Size: 22AWG, Spec: MIL-W-16878/4, Color: White, Length: 84.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "84.0\"",
            "wcLengthDesc": "84.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "84"
        },
        "BP": {
            "wireCode": "BP",
            "wcDesc": "22 AWG, MIL-W-16878/4, White, Length: 96\"",
            "wcMenuDesc": "BP (Size: 22AWG, Spec: MIL-W-16878/4, Color: White, Length: 96.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "NMIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "96.0\"",
            "wcLengthDesc": "96.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "96"
        },
        "BR": {
            "wireCode": "BR",
            "wcDesc": "22 AWG, MIL-W-16878/4, White, Length: 108\"",
            "wcMenuDesc": "BR (Size: 22AWG, Spec: MIL-W-16878/4, Color: White, Length: 108.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "108.0\"",
            "wcLengthDesc": "108.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "108"
        },
        "BS": {
            "wireCode": "BS",
            "wcDesc": "22 AWG, MIL-W-16878/4, White, Length: 120\"",
            "wcMenuDesc": "BS (Size: 22AWG, Spec: MIL-W-16878/4, Color: White, Length: 120.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "120.0\"",
            "wcLengthDesc": "120.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "120"
        },

        "CA": {
            "wireCode": "CA",
            "wcDesc": "24 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 6\"",
            "wcMenuDesc": "CA (Size: 24AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 6.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "6.0\"",
            "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "6"
        },
        "CB": {
            "wireCode": "CB",
            "wcDesc": "24 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 12\"",
            "wcMenuDesc": "CB (Size: 24AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 12.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "12.0\"",
            "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "12"
        },
        "CC": {
            "wireCode": "CC",
            "wcDesc": "24 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 18\"",
            "wcMenuDesc": "CC (Size: 24AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 18.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "18.0\"",
            "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "18"
        },
        "CD": {
            "wireCode": "CD",
            "wcDesc": "24 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 24\"",
            "wcMenuDesc": "CD (Size: 24AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 24.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "cWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "24.0\"",
            "wcLengthDesc": "24.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "24"
        },
        "CE": {
            "wireCode": "CE",
            "wcDesc": "24 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 30\"",
            "wcMenuDesc": "CE (Size: 24AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 30.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "30.0\"",
            "wcLengthDesc": "30.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "30"
        },
        "CF": {
            "wireCode": "CF",
            "wcDesc": "24 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 36\"",
            "wcMenuDesc": "CF (Size: 24AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 36.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "36.0\"",
            "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "36"
        },
        "CG": {
            "wireCode": "CG",
            "wcDesc": "24 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 42\"",
            "wcMenuDesc": "CG (Size: 24AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 42.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "42.0\"",
            "wcLengthDesc": "42.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "42"
        },
        "CH": {
            "wireCode": "CH",
            "wcDesc": "24 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 48\"",
            "wcMenuDesc": "CH (Size: 24AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 48.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "48.0\"",
            "wcLengthDesc": "48.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "48"
        },
        "CJ": {
            "wireCode": "CJ",
            "wcDesc": "24 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 54\"",
            "wcMenuDesc": "CJ (Size: 24AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 54.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "54.0\"",
            "wcLengthDesc": "54.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "54"
        },
        "CK": {
            "wireCode": "CK",
            "wcDesc": "24 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 60\"",
            "wcMenuDesc": "CK (Size: 24AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 60.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "60.0\"",
            "wcLengthDesc": "60.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "60"
        },
        "CL": {
            "wireCode": "CL",
            "wcDesc": "24 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 66\"",
            "wcMenuDesc": "CL (Size: 24AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 66.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "66.0\"",
            "wcLengthDesc": "66.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "66"
        },
        "CM": {
            "wireCode": "CM",
            "wcDesc": "24 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 72\"",
            "wcMenuDesc": "CM (Size: 24AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 72.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "72.0\"",
            "wcLengthDesc": "72.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "72"
        },
        "CN": {
            "wireCode": "CN",
            "wcDesc": "24 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 84\"",
            "wcMenuDesc": "CN (Size: 24AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 84.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "84.0\"",
            "wcLengthDesc": "84.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "84"
        },
        "CP": {
            "wireCode": "CP",
            "wcDesc": "24 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 96\"",
            "wcMenuDesc": "CP (Size: 24AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 96.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "NMIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "96.0\"",
            "wcLengthDesc": "96.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "96"
        },
        "CR": {
            "wireCode": "CR",
            "wcDesc": "24 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 108\"",
            "wcMenuDesc": "CR (Size: 24AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 108.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "108.0\"",
            "wcLengthDesc": "108.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "108"
        },
        "CS": {
            "wireCode": "CS",
            "wcDesc": "24 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 120\"",
            "wcMenuDesc": "CS (Size: 24AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 120.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "120.0\"",
            "wcLengthDesc": "120.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "120"
        },

        "DA": {
            "wireCode": "DA",
            "wcDesc": "24 AWG, MIL-W-16878/4, White, Length: 6\"",
            "wcMenuDesc": "DA (Size: 24AWG, Spec: MIL-W-16878/4, Color: White, Length: 6.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "6.0\"",
            "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "6"
        },
        "DB": {
            "wireCode": "DB",
            "wcDesc": "24 AWG, MIL-W-16878/4, White, Length: 12\"",
            "wcMenuDesc": "DB (Size: 24AWG, Spec: MIL-W-16878/4, Color: White, Length: 12.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "12.0\"",
            "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "12"
        },
        "DC": {
            "wireCode": "DC",
            "wcDesc": "24 AWG, MIL-W-16878/4, White, Length: 18\"",
            "wcMenuDesc": "DC (Size: 24AWG, Spec: MIL-W-16878/4, Color: White, Length: 18.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "18.0\"",
            "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "18"
        },
        "DD": {
            "wireCode": "DD",
            "wcDesc": "24 AWG, MIL-W-16878/4, White, Length: 24\"",
            "wcMenuDesc": "DD (Size: 24AWG, Spec: MIL-W-16878/4, Color: White, Length: 24.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "cWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "24.0\"",
            "wcLengthDesc": "24.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "24"
        },
        "DE": {
            "wireCode": "DE",
            "wcDesc": "24 AWG, MIL-W-16878/4, White, Length: 30\"",
            "wcMenuDesc": "DE (Size: 24AWG, Spec: MIL-W-16878/4, Color: White, Length: 30.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "30.0\"",
            "wcLengthDesc": "30.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "30"
        },
        "DF": {
            "wireCode": "DF",
            "wcDesc": "24 AWG, MIL-W-16878/4, White, Length: 36\"",
            "wcMenuDesc": "DF (Size: 24AWG, Spec: MIL-W-16878/4, Color: White, Length: 36.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "36.0\"",
            "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "36"
        },
        "DG": {
            "wireCode": "DG",
            "wcDesc": "24 AWG, MIL-W-16878/4, White, Length: 42\"",
            "wcMenuDesc": "DG (Size: 24AWG, Spec: MIL-W-16878/4, Color: White, Length: 42.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "42.0\"",
            "wcLengthDesc": "42.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "42"
        },
        "DH": {
            "wireCode": "DH",
            "wcDesc": "24 AWG, MIL-W-16878/4, White, Length: 48\"",
            "wcMenuDesc": "DH (Size: 24AWG, Spec: MIL-W-16878/4, Color: White, Length: 48.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "48.0\"",
            "wcLengthDesc": "48.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "48"
        },
        "DJ": {
            "wireCode": "DJ",
            "wcDesc": "24 AWG, MIL-W-16878/4, White, Length: 54\"",
            "wcMenuDesc": "DJ (Size: 24AWG, Spec: MIL-W-16878/4, Color: White, Length: 54.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "54.0\"",
            "wcLengthDesc": "54.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "54"
        },
        "DK": {
            "wireCode": "DK",
            "wcDesc": "24 AWG, MIL-W-16878/4, White, Length: 60\"",
            "wcMenuDesc": "DK (Size: 24AWG, Spec: MIL-W-16878/4, Color: White, Length: 60.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "60.0\"",
            "wcLengthDesc": "60.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "60"
        },
        "DL": {
            "wireCode": "DL",
            "wcDesc": "24 AWG, MIL-W-16878/4, White, Length: 66\"",
            "wcMenuDesc": "DL (Size: 24AWG, Spec: MIL-W-16878/4, Color: White, Length: 66.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "66.0\"",
            "wcLengthDesc": "66.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "66"
        },
        "DM": {
            "wireCode": "DM",
            "wcDesc": "24 AWG, MIL-W-16878/4, White, Length: 72\"",
            "wcMenuDesc": "DM (Size: 24AWG, Spec: MIL-W-16878/4, Color: White, Length: 72.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "72.0\"",
            "wcLengthDesc": "72.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "72"
        },
        "DN": {
            "wireCode": "DN",
            "wcDesc": "24 AWG, MIL-W-16878/4, White, Length: 84\"",
            "wcMenuDesc": "DN (Size: 24AWG, Spec: MIL-W-16878/4, Color: White, Length: 84.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "84.0\"",
            "wcLengthDesc": "84.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "84"
        },
        "DP": {
            "wireCode": "DP",
            "wcDesc": "24 AWG, MIL-W-16878/4, White, Length: 96\"",
            "wcMenuDesc": "DP (Size: 24AWG, Spec: MIL-W-16878/4, Color: White, Length: 96.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "NMIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "96.0\"",
            "wcLengthDesc": "96.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "96"
        },
        "DR": {
            "wireCode": "DR",
            "wcDesc": "24 AWG, MIL-W-16878/4, White, Length: 108\"",
            "wcMenuDesc": "DR (Size: 24AWG, Spec: MIL-W-16878/4, Color: White, Length: 108.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "108.0\"",
            "wcLengthDesc": "108.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "108"
        },
        "DS": {
            "wireCode": "DS",
            "wcDesc": "24 AWG, MIL-W-16878/4, White, Length: 120\"",
            "wcMenuDesc": "DS (Size: 24AWG, Spec: MIL-W-16878/4, Color: White, Length: 120.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "120.0\"",
            "wcLengthDesc": "120.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "120"
        },

        "EA": {
            "wireCode": "EA",
            "wcDesc": "26 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 6\"",
            "wcMenuDesc": "EA (Size: 26AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 6.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "6.0\"",
            "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "6"
        },
        "EB": {
            "wireCode": "EB",
            "wcDesc": "26 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 12\"",
            "wcMenuDesc": "EB (Size: 26AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 12.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "12.0\"",
            "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "12"
        },
        "EC": {
            "wireCode": "EC",
            "wcDesc": "26 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 18\"",
            "wcMenuDesc": "EC (Size: 26AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 18.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "18.0\"",
            "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "18"
        },
        "ED": {
            "wireCode": "ED",
            "wcDesc": "26 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 26\"",
            "wcMenuDesc": "ED (Size: 26AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 26.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "cWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "26.0\"",
            "wcLengthDesc": "26.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "26"
        },
        "EE": {
            "wireCode": "EE",
            "wcDesc": "26 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 30\"",
            "wcMenuDesc": "EE (Size: 26AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 30.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "30.0\"",
            "wcLengthDesc": "30.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "30"
        },
        "EF": {
            "wireCode": "EF",
            "wcDesc": "26 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 36\"",
            "wcMenuDesc": "EF (Size: 26AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 36.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "36.0\"",
            "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "36"
        },
        "EG": {
            "wireCode": "EG",
            "wcDesc": "26 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 42\"",
            "wcMenuDesc": "EG (Size: 26AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 42.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "42.0\"",
            "wcLengthDesc": "42.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "42"
        },
        "EH": {
            "wireCode": "EH",
            "wcDesc": "26 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 48\"",
            "wcMenuDesc": "EH (Size: 26AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 48.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "48.0\"",
            "wcLengthDesc": "48.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "48"
        },
        "EJ": {
            "wireCode": "EJ",
            "wcDesc": "26 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 54\"",
            "wcMenuDesc": "EJ (Size: 26AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 54.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "54.0\"",
            "wcLengthDesc": "54.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "54"
        },
        "EK": {
            "wireCode": "EK",
            "wcDesc": "26 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 60\"",
            "wcMenuDesc": "EK (Size: 26AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 60.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "60.0\"",
            "wcLengthDesc": "60.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "60"
        },
        "EL": {
            "wireCode": "EL",
            "wcDesc": "26 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 66\"",
            "wcMenuDesc": "EL (Size: 26AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 66.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "66.0\"",
            "wcLengthDesc": "66.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "66"
        },
        "EM": {
            "wireCode": "EM",
            "wcDesc": "26 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 72\"",
            "wcMenuDesc": "EM (Size: 26AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 72.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "72.0\"",
            "wcLengthDesc": "72.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "72"
        },
        "EN": {
            "wireCode": "EN",
            "wcDesc": "26 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 84\"",
            "wcMenuDesc": "EN (Size: 26AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 84.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "84.0\"",
            "wcLengthDesc": "84.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "84"
        },
        "EP": {
            "wireCode": "EP",
            "wcDesc": "26 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 96\"",
            "wcMenuDesc": "EP (Size: 26AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 96.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "NMIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "96.0\"",
            "wcLengthDesc": "96.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "96"
        },
        "ER": {
            "wireCode": "ER",
            "wcDesc": "26 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 108\"",
            "wcMenuDesc": "ER (Size: 26AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 108.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "108.0\"",
            "wcLengthDesc": "108.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "108"
        },
        "ES": {
            "wireCode": "ES",
            "wcDesc": "26 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 120\"",
            "wcMenuDesc": "ES (Size: 26AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 120.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "120.0\"",
            "wcLengthDesc": "120.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "120"
        },

        "FA": {
            "wireCode": "FA",
            "wcDesc": "26 AWG, MIL-W-16878/4, White, Length: 6\"",
            "wcMenuDesc": "FA (Size: 26AWG, Spec: MIL-W-16878/4, Color: White, Length: 6.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "6.0\"",
            "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "6"
        },
        "FB": {
            "wireCode": "FB",
            "wcDesc": "26 AWG, MIL-W-16878/4, White, Length: 12\"",
            "wcMenuDesc": "FB (Size: 26AWG, Spec: MIL-W-16878/4, Color: White, Length: 12.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "12.0\"",
            "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "12"
        },
        "FC": {
            "wireCode": "F",
            "wcDesc": "26 AWG, MIL-W-16878/4, White, Length: 18\"",
            "wcMenuDesc": "FC (Size: 26AWG, Spec: MIL-W-16878/4, Color: White, Length: 18.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "18.0\"",
            "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "18"
        },
        "FD": {
            "wireCode": "FD",
            "wcDesc": "26 AWG, MIL-W-16878/4, White, Length: 26\"",
            "wcMenuDesc": "FD (Size: 26AWG, Spec: MIL-W-16878/4, Color: White, Length: 26.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "cWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "26.0\"",
            "wcLengthDesc": "26.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "26"
        },
        "FE": {
            "wireCode": "FE",
            "wcDesc": "26 AWG, MIL-W-16878/4, White, Length: 30\"",
            "wcMenuDesc": "FE (Size: 26AWG, Spec: MIL-W-16878/4, Color: White, Length: 30.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "30.0\"",
            "wcLengthDesc": "30.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "30"
        },
        "FF": {
            "wireCode": "FF",
            "wcDesc": "26 AWG, MIL-W-16878/4, White, Length: 36\"",
            "wcMenuDesc": "FF (Size: 26AWG, Spec: MIL-W-16878/4, Color: White, Length: 36.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "36.0\"",
            "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "36"
        },
        "FG": {
            "wireCode": "FG",
            "wcDesc": "26 AWG, MIL-W-16878/4, White, Length: 42\"",
            "wcMenuDesc": "FG (Size: 26AWG, Spec: MIL-W-16878/4, Color: White, Length: 42.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "42.0\"",
            "wcLengthDesc": "42.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "42"
        },
        "FH": {
            "wireCode": "FH",
            "wcDesc": "26 AWG, MIL-W-16878/4, White, Length: 48\"",
            "wcMenuDesc": "FH (Size: 26AWG, Spec: MIL-W-16878/4, Color: White, Length: 48.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "48.0\"",
            "wcLengthDesc": "48.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "48"
        },
        "FJ": {
            "wireCode": "FJ",
            "wcDesc": "26 AWG, MIL-W-16878/4, White, Length: 54\"",
            "wcMenuDesc": "FJ (Size: 26AWG, Spec: MIL-W-16878/4, Color: White, Length: 54.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "54.0\"",
            "wcLengthDesc": "54.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "54"
        },
        "FK": {
            "wireCode": "FK",
            "wcDesc": "26 AWG, MIL-W-16878/4, White, Length: 60\"",
            "wcMenuDesc": "FK (Size: 26AWG, Spec: MIL-W-16878/4, Color: White, Length: 60.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "60.0\"",
            "wcLengthDesc": "60.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "60"
        },
        "FL": {
            "wireCode": "FL",
            "wcDesc": "26 AWG, MIL-W-16878/4, White, Length: 66\"",
            "wcMenuDesc": "FL (Size: 26AWG, Spec: MIL-W-16878/4, Color: White, Length: 66.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "66.0\"",
            "wcLengthDesc": "66.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "66"
        },
        "FM": {
            "wireCode": "FM",
            "wcDesc": "26 AWG, MIL-W-16878/4, White, Length: 72\"",
            "wcMenuDesc": "FM (Size: 26AWG, Spec: MIL-W-16878/4, Color: White, Length: 72.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "72.0\"",
            "wcLengthDesc": "72.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "72"
        },
        "FN": {
            "wireCode": "FN",
            "wcDesc": "26 AWG, MIL-W-16878/4, White, Length: 84\"",
            "wcMenuDesc": "FN (Size: 26AWG, Spec: MIL-W-16878/4, Color: White, Length: 84.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "84.0\"",
            "wcLengthDesc": "84.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "84"
        },
        "FP": {
            "wireCode": "FP",
            "wcDesc": "26 AWG, MIL-W-16878/4, White, Length: 96\"",
            "wcMenuDesc": "FP (Size: 26AWG, Spec: MIL-W-16878/4, Color: White, Length: 96.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "NMIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "96.0\"",
            "wcLengthDesc": "96.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "96"
        },
        "FR": {
            "wireCode": "FR",
            "wcDesc": "26 AWG, MIL-W-16878/4, White, Length: 108\"",
            "wcMenuDesc": "FR (Size: 26AWG, Spec: MIL-W-16878/4, Color: White, Length: 108.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "108.0\"",
            "wcLengthDesc": "108.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "108"
        },
        "FS": {
            "wireCode": "FS",
            "wcDesc": "26 AWG, MIL-W-16878/4, White, Length: 120\"",
            "wcMenuDesc": "FS (Size: 26AWG, Spec: MIL-W-16878/4, Color: White, Length: 120.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "120.0\"",
            "wcLengthDesc": "120.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "120"
        },

        "GA": {
            "wireCode": "GA",
            "wcDesc": "28 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 6\"",
            "wcMenuDesc": "GA (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 6.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "6.0\"",
            "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "6"
        },
        "GB": {
            "wireCode": "GB",
            "wcDesc": "28 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 12\"",
            "wcMenuDesc": "GB (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 12.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "12.0\"",
            "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "12"
        },
        "GC": {
            "wireCode": "GC",
            "wcDesc": "28 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 18\"",
            "wcMenuDesc": "GC (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 18.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "18.0\"",
            "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "18"
        },
        "GD": {
            "wireCode": "GD",
            "wcDesc": "28 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 26\"",
            "wcMenuDesc": "GD (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 26.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "cWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "26.0\"",
            "wcLengthDesc": "26.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "26"
        },
        "GE": {
            "wireCode": "GE",
            "wcDesc": "28 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 30\"",
            "wcMenuDesc": "GE (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 30.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "30.0\"",
            "wcLengthDesc": "30.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "30"
        },
        "GF": {
            "wireCode": "GF",
            "wcDesc": "28 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 36\"",
            "wcMenuDesc": "GF (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 36.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "36.0\"",
            "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "36"
        },
        "GG": {
            "wireCode": "GG",
            "wcDesc": "28 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 42\"",
            "wcMenuDesc": "GG (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 42.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "42.0\"",
            "wcLengthDesc": "42.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "42"
        },
        "GH": {
            "wireCode": "GH",
            "wcDesc": "28 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 48\"",
            "wcMenuDesc": "GH (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 48.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "48.0\"",
            "wcLengthDesc": "48.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "48"
        },
        "GJ": {
            "wireCode": "GJ",
            "wcDesc": "28 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 54\"",
            "wcMenuDesc": "GJ (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 54.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "54.0\"",
            "wcLengthDesc": "54.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "54"
        },
        "GK": {
            "wireCode": "GK",
            "wcDesc": "28 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 60\"",
            "wcMenuDesc": "GK (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 60.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "60.0\"",
            "wcLengthDesc": "60.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "60"
        },
        "GL": {
            "wireCode": "GL",
            "wcDesc": "28 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 66\"",
            "wcMenuDesc": "GL (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 66.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "66.0\"",
            "wcLengthDesc": "66.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "66"
        },
        "GM": {
            "wireCode": "GM",
            "wcDesc": "28 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 72\"",
            "wcMenuDesc": "GM (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 72.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "72.0\"",
            "wcLengthDesc": "72.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "72"
        },
        "GN": {
            "wireCode": "GN",
            "wcDesc": "28 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 84\"",
            "wcMenuDesc": "GN (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 84.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "84.0\"",
            "wcLengthDesc": "84.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "84"
        },
        "GP": {
            "wireCode": "GP",
            "wcDesc": "28 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 96\"",
            "wcMenuDesc": "GP (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 96.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "NMIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "96.0\"",
            "wcLengthDesc": "96.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "96"
        },
        "GR": {
            "wireCode": "GR",
            "wcDesc": "28 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 108\"",
            "wcMenuDesc": "GR (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 108.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "108.0\"",
            "wcLengthDesc": "108.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "108"
        },
        "GS": {
            "wireCode": "GS",
            "wcDesc": "28 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 120\"",
            "wcMenuDesc": "GS (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 120.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "120.0\"",
            "wcLengthDesc": "120.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "120"
        },

        "HA": {
            "wireCode": "HA",
            "wcDesc": "28 AWG, MIL-W-16878/4, White, Length: 6\"",
            "wcMenuDesc": "HA (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 6.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "6.0\"",
            "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "6"
        },
        "HB": {
            "wireCode": "HB",
            "wcDesc": "28 AWG, MIL-W-16878/4, White, Length: 12\"",
            "wcMenuDesc": "HB (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 12.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "12.0\"",
            "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "12"
        },
        "HC": {
            "wireCode": "H",
            "wcDesc": "28 AWG, MIL-W-16878/4, White, Length: 18\"",
            "wcMenuDesc": "HC (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 18.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "18.0\"",
            "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "18"
        },
        "HD": {
            "wireCode": "HD",
            "wcDesc": "28 AWG, MIL-W-16878/4, White, Length: 26\"",
            "wcMenuDesc": "HD (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 26.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "cWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "26.0\"",
            "wcLengthDesc": "26.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "26"
        },
        "HE": {
            "wireCode": "HE",
            "wcDesc": "28 AWG, MIL-W-16878/4, White, Length: 30\"",
            "wcMenuDesc": "HE (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 30.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "30.0\"",
            "wcLengthDesc": "30.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "30"
        },
        "HF": {
            "wireCode": "HF",
            "wcDesc": "28 AWG, MIL-W-16878/4, White, Length: 36\"",
            "wcMenuDesc": "HF (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 36.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "36.0\"",
            "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "36"
        },
        "HG": {
            "wireCode": "HG",
            "wcDesc": "28 AWG, MIL-W-16878/4, White, Length: 42\"",
            "wcMenuDesc": "HG (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 42.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "42.0\"",
            "wcLengthDesc": "42.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "42"
        },
        "HH": {
            "wireCode": "HH",
            "wcDesc": "28 AWG, MIL-W-16878/4, White, Length: 48\"",
            "wcMenuDesc": "HH (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 48.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "48.0\"",
            "wcLengthDesc": "48.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "48"
        },
        "HJ": {
            "wireCode": "HJ",
            "wcDesc": "28 AWG, MIL-W-16878/4, White, Length: 54\"",
            "wcMenuDesc": "HJ (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 54.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "54.0\"",
            "wcLengthDesc": "54.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "54"
        },
        "HK": {
            "wireCode": "HK",
            "wcDesc": "28 AWG, MIL-W-16878/4, White, Length: 60\"",
            "wcMenuDesc": "HK (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 60.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "60.0\"",
            "wcLengthDesc": "60.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "60"
        },
        "HL": {
            "wireCode": "HL",
            "wcDesc": "28 AWG, MIL-W-16878/4, White, Length: 66\"",
            "wcMenuDesc": "HL (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 66.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "66.0\"",
            "wcLengthDesc": "66.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "66"
        },
        "HM": {
            "wireCode": "HM",
            "wcDesc": "28 AWG, MIL-W-16878/4, White, Length: 72\"",
            "wcMenuDesc": "HM (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 72.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "72.0\"",
            "wcLengthDesc": "72.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "72"
        },
        "HN": {
            "wireCode": "HN",
            "wcDesc": "28 AWG, MIL-W-16878/4, White, Length: 84\"",
            "wcMenuDesc": "HN (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 84.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "84.0\"",
            "wcLengthDesc": "84.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "84"
        },
        "HP": {
            "wireCode": "HP",
            "wcDesc": "28 AWG, MIL-W-16878/4, White, Length: 96\"",
            "wcMenuDesc": "HP (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 96.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "NMIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "96.0\"",
            "wcLengthDesc": "96.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "96"
        },
        "HR": {
            "wireCode": "HR",
            "wcDesc": "28 AWG, MIL-W-16878/4, White, Length: 108\"",
            "wcMenuDesc": "HR (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 108.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "108.0\"",
            "wcLengthDesc": "108.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "108"
        },
        "HS": {
            "wireCode": "HS",
            "wcDesc": "28 AWG, MIL-W-16878/4, White, Length: 120\"",
            "wcMenuDesc": "HS (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 120.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "120.0\"",
            "wcLengthDesc": "120.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "120"
        },

        "JA": {
            "wireCode": "JA",
            "wcDesc": "30 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 6\"",
            "wcMenuDesc": "JA (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 6.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "6.0\"",
            "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "6"
        },
        "JB": {
            "wireCode": "JB",
            "wcDesc": "30 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 12\"",
            "wcMenuDesc": "JB (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 12.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "12.0\"",
            "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "12"
        },
        "JC": {
            "wireCode": "JC",
            "wcDesc": "30 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 18\"",
            "wcMenuDesc": "JC (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 18.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "18.0\"",
            "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "18"
        },
        "JD": {
            "wireCode": "JD",
            "wcDesc": "30 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 26\"",
            "wcMenuDesc": "JD (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 26.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "cWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "26.0\"",
            "wcLengthDesc": "26.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "26"
        },
        "JE": {
            "wireCode": "JE",
            "wcDesc": "30 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 30\"",
            "wcMenuDesc": "JE (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 30.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "30.0\"",
            "wcLengthDesc": "30.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "30"
        },
        "JF": {
            "wireCode": "JF",
            "wcDesc": "30 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 36\"",
            "wcMenuDesc": "JF (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 36.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "36.0\"",
            "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "36"
        },
        "JG": {
            "wireCode": "JG",
            "wcDesc": "30 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 42\"",
            "wcMenuDesc": "JG (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 42.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "42.0\"",
            "wcLengthDesc": "42.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "42"
        },
        "JH": {
            "wireCode": "JH",
            "wcDesc": "30 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 48\"",
            "wcMenuDesc": "JH (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 48.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "48.0\"",
            "wcLengthDesc": "48.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "48"
        },
        "JJ": {
            "wireCode": "JJ",
            "wcDesc": "30 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 54\"",
            "wcMenuDesc": "JJ (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 54.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "54.0\"",
            "wcLengthDesc": "54.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "54"
        },
        "JK": {
            "wireCode": "JK",
            "wcDesc": "30 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 60\"",
            "wcMenuDesc": "JK (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 60.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "60.0\"",
            "wcLengthDesc": "60.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "60"
        },
        "JL": {
            "wireCode": "JL",
            "wcDesc": "30 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 66\"",
            "wcMenuDesc": "JL (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 66.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "66.0\"",
            "wcLengthDesc": "66.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "66"
        },
        "JM": {
            "wireCode": "JM",
            "wcDesc": "30 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 72\"",
            "wcMenuDesc": "JM (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 72.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "72.0\"",
            "wcLengthDesc": "72.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "72"
        },
        "JN": {
            "wireCode": "JN",
            "wcDesc": "30 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 84\"",
            "wcMenuDesc": "JN (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 84.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "84.0\"",
            "wcLengthDesc": "84.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "84"
        },
        "JP": {
            "wireCode": "JP",
            "wcDesc": "30 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 96\"",
            "wcMenuDesc": "JP (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 96.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "NMIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "96.0\"",
            "wcLengthDesc": "96.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "96"
        },
        "JR": {
            "wireCode": "JR",
            "wcDesc": "30 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 108\"",
            "wcMenuDesc": "JR (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 108.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "108.0\"",
            "wcLengthDesc": "108.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "108"
        },
        "JS": {
            "wireCode": "JS",
            "wcDesc": "30 AWG, MIL-W-16878/4, Ten Colors Repeating, Length: 120\"",
            "wcMenuDesc": "JS (Size: 28AWG, Spec: MIL-W-16878/4, Color: Ten Colors Repeating, Length: 120.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "120.0\"",
            "wcLengthDesc": "120.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "120"
        },

        "KA": {
            "wireCode": "KA",
            "wcDesc": "30 AWG, MIL-W-16878/4, White, Length: 6\"",
            "wcMenuDesc": "KA (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 6.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "6.0\"",
            "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "6"
        },
        "KB": {
            "wireCode": "KB",
            "wcDesc": "30 AWG, MIL-W-16878/4, White, Length: 12\"",
            "wcMenuDesc": "KB (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 12.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "12.0\"",
            "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "12"
        },
        "KC": {
            "wireCode": "K",
            "wcDesc": "30 AWG, MIL-W-16878/4, White, Length: 18\"",
            "wcMenuDesc": "KC (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 18.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "18.0\"",
            "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "18"
        },
        "KD": {
            "wireCode": "KD",
            "wcDesc": "30 AWG, MIL-W-16878/4, White, Length: 26\"",
            "wcMenuDesc": "KD (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 26.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "cWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "26.0\"",
            "wcLengthDesc": "26.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "26"
        },
        "KE": {
            "wireCode": "KE",
            "wcDesc": "30 AWG, MIL-W-16878/4, White, Length: 30\"",
            "wcMenuDesc": "KE (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 30.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "30.0\"",
            "wcLengthDesc": "30.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "30"
        },
        "KF": {
            "wireCode": "KF",
            "wcDesc": "30 AWG, MIL-W-16878/4, White, Length: 36\"",
            "wcMenuDesc": "KF (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 36.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "36.0\"",
            "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "36"
        },
        "KG": {
            "wireCode": "KG",
            "wcDesc": "30 AWG, MIL-W-16878/4, White, Length: 42\"",
            "wcMenuDesc": "KG (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 42.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "42.0\"",
            "wcLengthDesc": "42.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "42"
        },
        "KH": {
            "wireCode": "KH",
            "wcDesc": "30 AWG, MIL-W-16878/4, White, Length: 48\"",
            "wcMenuDesc": "KH (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 48.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "48.0\"",
            "wcLengthDesc": "48.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "48"
        },
        "KJ": {
            "wireCode": "KJ",
            "wcDesc": "30 AWG, MIL-W-16878/4, White, Length: 54\"",
            "wcMenuDesc": "KJ (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 54.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "54.0\"",
            "wcLengthDesc": "54.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "54"
        },
        "KK": {
            "wireCode": "KK",
            "wcDesc": "30 AWG, MIL-W-16878/4, White, Length: 60\"",
            "wcMenuDesc": "KK (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 60.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "60.0\"",
            "wcLengthDesc": "60.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "60"
        },
        "KL": {
            "wireCode": "KL",
            "wcDesc": "30 AWG, MIL-W-16878/4, White, Length: 66\"",
            "wcMenuDesc": "KL (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 66.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "66.0\"",
            "wcLengthDesc": "66.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "66"
        },
        "KM": {
            "wireCode": "KM",
            "wcDesc": "30 AWG, MIL-W-16878/4, White, Length: 72\"",
            "wcMenuDesc": "KM (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 72.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "72.0\"",
            "wcLengthDesc": "72.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "72"
        },
        "KN": {
            "wireCode": "KN",
            "wcDesc": "30 AWG, MIL-W-16878/4, White, Length: 84\"",
            "wcMenuDesc": "KN (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 84.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "84.0\"",
            "wcLengthDesc": "84.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "84"
        },
        "KP": {
            "wireCode": "KP",
            "wcDesc": "30 AWG, MIL-W-16878/4, White, Length: 96\"",
            "wcMenuDesc": "KP (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 96.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "NMIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "96.0\"",
            "wcLengthDesc": "96.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "96"
        },
        "KR": {
            "wireCode": "KR",
            "wcDesc": "30 AWG, MIL-W-16878/4, White, Length: 108\"",
            "wcMenuDesc": "KR (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 108.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "108.0\"",
            "wcLengthDesc": "108.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "108"
        },
        "KS": {
            "wireCode": "KS",
            "wcDesc": "30 AWG, MIL-W-16878/4, White, Length: 120\"",
            "wcMenuDesc": "KS (Size: 28AWG, Spec: MIL-W-16878/4, Color: White, Length: 120.0\")",
            "wcSpec": "MIL-W-16878/4",
            "wcSpecDesc": "MIL-W-16878/4",
            "wcSpecMenu": "MIL-W-16878/4",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "120.0\"",
            "wcLengthDesc": "120.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "120"
        },


        "LA": {
            "wireCode": "LA",
            "wcDesc": "22 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 6\"",
            "wcMenuDesc": "LA (Size: 22AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 6.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "6.0\"",
            "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "6"
        },
        "LB": {
            "wireCode": "LB",
            "wcDesc": "22 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 12\"",
            "wcMenuDesc": "LB (Size: 22AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 12.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "12.0\"",
            "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "12"
        },
        "LC": {
            "wireCode": "LC",
            "wcDesc": "22 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 18\"",
            "wcMenuDesc": "LC (Size: 22AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 18.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "18.0\"",
            "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "18"
        },
        "LD": {
            "wireCode": "LD",
            "wcDesc": "22 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 24\"",
            "wcMenuDesc": "LD (Size: 22AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 24.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "cWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "24.0\"",
            "wcLengthDesc": "24.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "24"
        },
        "LE": {
            "wireCode": "LE",
            "wcDesc": "22 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 30\"",
            "wcMenuDesc": "LE (Size: 22AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 30.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "30.0\"",
            "wcLengthDesc": "30.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "30"
        },
        "LF": {
            "wireCode": "LF",
            "wcDesc": "22 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 36\"",
            "wcMenuDesc": "LF (Size: 22AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 36.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "36.0\"",
            "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "36"
        },
        "LG": {
            "wireCode": "LG",
            "wcDesc": "22 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 42\"",
            "wcMenuDesc": "LG (Size: 22AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 42.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "42.0\"",
            "wcLengthDesc": "42.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "42"
        },
        "LH": {
            "wireCode": "LH",
            "wcDesc": "22 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 48\"",
            "wcMenuDesc": "LH (Size: 22AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 48.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "48.0\"",
            "wcLengthDesc": "48.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "48"
        },
        "LJ": {
            "wireCode": "LJ",
            "wcDesc": "22 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 54\"",
            "wcMenuDesc": "LJ (Size: 22AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 54.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "54.0\"",
            "wcLengthDesc": "54.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "54"
        },
        "LK": {
            "wireCode": "LK",
            "wcDesc": "22 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 60\"",
            "wcMenuDesc": "LK (Size: 22AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 60.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "60.0\"",
            "wcLengthDesc": "60.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "60"
        },
        "LL": {
            "wireCode": "LL",
            "wcDesc": "22 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 66\"",
            "wcMenuDesc": "LL (Size: 22AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 66.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "66.0\"",
            "wcLengthDesc": "66.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "66"
        },
        "LM": {
            "wireCode": "LM",
            "wcDesc": "22 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 72\"",
            "wcMenuDesc": "LM (Size: 22AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 72.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "72.0\"",
            "wcLengthDesc": "72.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "72"
        },
        "LN": {
            "wireCode": "LN",
            "wcDesc": "22 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 84\"",
            "wcMenuDesc": "LN (Size: 22AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 84.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "84.0\"",
            "wcLengthDesc": "84.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "84"
        },
        "LP": {
            "wireCode": "LP",
            "wcDesc": "22 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 96\"",
            "wcMenuDesc": "LP (Size: 22AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 96.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "NMIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "96.0\"",
            "wcLengthDesc": "96.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "96"
        },
        "LR": {
            "wireCode": "LR",
            "wcDesc": "22 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 108\"",
            "wcMenuDesc": "LR (Size: 22AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 108.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "108.0\"",
            "wcLengthDesc": "108.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "108"
        },
        "LS": {
            "wireCode": "LS",
            "wcDesc": "22 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 120\"",
            "wcMenuDesc": "LS (Size: 22AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 120.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "120.0\"",
            "wcLengthDesc": "120.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "120"
        },

        "MA": {
            "wireCode": "MA",
            "wcDesc": "22 AWG, MIL-W-22759/33, White, Length: 6\"",
            "wcMenuDesc": "MA (Size: 22AWG, Spec: MIL-W-22759/33, Color: White, Length: 6.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "6.0\"",
            "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "6"
        },
        "MB": {
            "wireCode": "MB",
            "wcDesc": "22 AWG, MIL-W-22759/33, White, Length: 12\"",
            "wcMenuDesc": "MB (Size: 22AWG, Spec: MIL-W-22759/33, Color: White, Length: 12.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "12.0\"",
            "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "12"
        },
        "MC": {
            "wireCode": "MC",
            "wcDesc": "22 AWG, MIL-W-22759/33, White, Length: 18\"",
            "wcMenuDesc": "MC (Size: 22AWG, Spec: MIL-W-22759/33, Color: White, Length: 18.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "18.0\"",
            "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "18"
        },
        "MD": {
            "wireCode": "MD",
            "wcDesc": "22 AWG, MIL-W-22759/33, White, Length: 24\"",
            "wcMenuDesc": "MD (Size: 22AWG, Spec: MIL-W-22759/33, Color: White, Length: 24.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "cWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "24.0\"",
            "wcLengthDesc": "24.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "24"
        },
        "ME": {
            "wireCode": "ME",
            "wcDesc": "22 AWG, MIL-W-22759/33, White, Length: 30\"",
            "wcMenuDesc": "ME (Size: 22AWG, Spec: MIL-W-22759/33, Color: White, Length: 30.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "30.0\"",
            "wcLengthDesc": "30.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "30"
        },
        "MF": {
            "wireCode": "MF",
            "wcDesc": "22 AWG, MIL-W-22759/33, White, Length: 36\"",
            "wcMenuDesc": "MF (Size: 22AWG, Spec: MIL-W-22759/33, Color: White, Length: 36.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "36.0\"",
            "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "36"
        },
        "MG": {
            "wireCode": "MG",
            "wcDesc": "22 AWG, MIL-W-22759/33, White, Length: 42\"",
            "wcMenuDesc": "MG (Size: 22AWG, Spec: MIL-W-22759/33, Color: White, Length: 42.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "42.0\"",
            "wcLengthDesc": "42.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "42"
        },
        "MH": {
            "wireCode": "MH",
            "wcDesc": "22 AWG, MIL-W-22759/33, White, Length: 48\"",
            "wcMenuDesc": "MH (Size: 22AWG, Spec: MIL-W-22759/33, Color: White, Length: 48.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "48.0\"",
            "wcLengthDesc": "48.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "48"
        },
        "MJ": {
            "wireCode": "MJ",
            "wcDesc": "22 AWG, MIL-W-22759/33, White, Length: 54\"",
            "wcMenuDesc": "MJ (Size: 22AWG, Spec: MIL-W-22759/33, Color: White, Length: 54.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "54.0\"",
            "wcLengthDesc": "54.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "54"
        },
        "MK": {
            "wireCode": "MK",
            "wcDesc": "22 AWG, MIL-W-22759/33, White, Length: 60\"",
            "wcMenuDesc": "MK (Size: 22AWG, Spec: MIL-W-22759/33, Color: White, Length: 60.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "60.0\"",
            "wcLengthDesc": "60.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "60"
        },
        "ML": {
            "wireCode": "ML",
            "wcDesc": "22 AWG, MIL-W-22759/33, White, Length: 66\"",
            "wcMenuDesc": "ML (Size: 22AWG, Spec: MIL-W-22759/33, Color: White, Length: 66.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "66.0\"",
            "wcLengthDesc": "66.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "66"
        },
        "MM": {
            "wireCode": "MM",
            "wcDesc": "22 AWG, MIL-W-22759/33, White, Length: 72\"",
            "wcMenuDesc": "MM (Size: 22AWG, Spec: MIL-W-22759/33, Color: White, Length: 72.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "72.0\"",
            "wcLengthDesc": "72.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "72"
        },
        "MN": {
            "wireCode": "MN",
            "wcDesc": "22 AWG, MIL-W-22759/33, White, Length: 84\"",
            "wcMenuDesc": "MN (Size: 22AWG, Spec: MIL-W-22759/33, Color: White, Length: 84.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "84.0\"",
            "wcLengthDesc": "84.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "84"
        },
        "MP": {
            "wireCode": "MP",
            "wcDesc": "22 AWG, MIL-W-22759/33, White, Length: 96\"",
            "wcMenuDesc": "MP (Size: 22AWG, Spec: MIL-W-22759/33, Color: White, Length: 96.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "NMIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "96.0\"",
            "wcLengthDesc": "96.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "96"
        },
        "MR": {
            "wireCode": "MR",
            "wcDesc": "22 AWG, MIL-W-22759/33, White, Length: 108\"",
            "wcMenuDesc": "MR (Size: 22AWG, Spec: MIL-W-22759/33, Color: White, Length: 108.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "108.0\"",
            "wcLengthDesc": "108.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "108"
        },
        "MS": {
            "wireCode": "MS",
            "wcDesc": "22 AWG, MIL-W-22759/33, White, Length: 120\"",
            "wcMenuDesc": "MS (Size: 22AWG, Spec: MIL-W-22759/33, Color: White, Length: 120.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "22 AWG",
            "wcWireSizeDesc": "22 AWG",
            "wcWireSizeMenu": "22",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "120.0\"",
            "wcLengthDesc": "120.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "120"
        },

        "NA": {
            "wireCode": "NA",
            "wcDesc": "24 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 6\"",
            "wcMenuDesc": "NA (Size: 24AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 6.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "6.0\"",
            "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "6"
        },
        "NB": {
            "wireCode": "NB",
            "wcDesc": "24 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 12\"",
            "wcMenuDesc": "NB (Size: 24AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 12.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "12.0\"",
            "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "12"
        },
        "NC": {
            "wireCode": "NC",
            "wcDesc": "24 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 18\"",
            "wcMenuDesc": "NC (Size: 24AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 18.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "18.0\"",
            "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "18"
        },
        "ND": {
            "wireCode": "ND",
            "wcDesc": "24 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 24\"",
            "wcMenuDesc": "ND (Size: 24AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 24.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "NWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "24.0\"",
            "wcLengthDesc": "24.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "24"
        },
        "NE": {
            "wireCode": "NE",
            "wcDesc": "24 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 30\"",
            "wcMenuDesc": "NE (Size: 24AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 30.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "30.0\"",
            "wcLengthDesc": "30.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "30"
        },
        "NF": {
            "wireCode": "NF",
            "wcDesc": "24 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 36\"",
            "wcMenuDesc": "NF (Size: 24AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 36.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "36.0\"",
            "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "36"
        },
        "NG": {
            "wireCode": "NG",
            "wcDesc": "24 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 42\"",
            "wcMenuDesc": "NG (Size: 24AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 42.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "42.0\"",
            "wcLengthDesc": "42.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "42"
        },
        "NH": {
            "wireCode": "NH",
            "wcDesc": "24 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 48\"",
            "wcMenuDesc": "NH (Size: 24AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 48.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "48.0\"",
            "wcLengthDesc": "48.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "48"
        },
        "NJ": {
            "wireCode": "NJ",
            "wcDesc": "24 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 54\"",
            "wcMenuDesc": "NJ (Size: 24AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 54.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "54.0\"",
            "wcLengthDesc": "54.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "54"
        },
        "NK": {
            "wireCode": "NK",
            "wcDesc": "24 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 60\"",
            "wcMenuDesc": "NK (Size: 24AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 60.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "60.0\"",
            "wcLengthDesc": "60.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "60"
        },
        "NL": {
            "wireCode": "NL",
            "wcDesc": "24 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 66\"",
            "wcMenuDesc": "NL (Size: 24AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 66.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "66.0\"",
            "wcLengthDesc": "66.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "66"
        },
        "NM": {
            "wireCode": "NM",
            "wcDesc": "24 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 72\"",
            "wcMenuDesc": "NM (Size: 24AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 72.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "72.0\"",
            "wcLengthDesc": "72.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "72"
        },
        "NN": {
            "wireCode": "NN",
            "wcDesc": "24 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 84\"",
            "wcMenuDesc": "NN (Size: 24AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 84.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "84.0\"",
            "wcLengthDesc": "84.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "84"
        },
        "NP": {
            "wireCode": "NP",
            "wcDesc": "24 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 96\"",
            "wcMenuDesc": "NP (Size: 24AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 96.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "NMIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "96.0\"",
            "wcLengthDesc": "96.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "96"
        },
        "NR": {
            "wireCode": "NR",
            "wcDesc": "24 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 108\"",
            "wcMenuDesc": "NR (Size: 24AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 108.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "108.0\"",
            "wcLengthDesc": "108.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "108"
        },
        "NS": {
            "wireCode": "NS",
            "wcDesc": "24 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 120\"",
            "wcMenuDesc": "NS (Size: 24AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 120.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "120.0\"",
            "wcLengthDesc": "120.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "120"
        },

        "PA": {
            "wireCode": "PA",
            "wcDesc": "24 AWG, MIL-W-22759/33, White, Length: 6\"",
            "wcMenuDesc": "PA (Size: 24AWG, Spec: MIL-W-22759/33, Color: White, Length: 6.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "6.0\"",
            "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "6"
        },
        "PB": {
            "wireCode": "PB",
            "wcDesc": "24 AWG, MIL-W-22759/33, White, Length: 12\"",
            "wcMenuDesc": "PB (Size: 24AWG, Spec: MIL-W-22759/33, Color: White, Length: 12.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "12.0\"",
            "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "12"
        },
        "PC": {
            "wireCode": "PC",
            "wcDesc": "24 AWG, MIL-W-22759/33, White, Length: 18\"",
            "wcMenuDesc": "PC (Size: 24AWG, Spec: MIL-W-22759/33, Color: White, Length: 18.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "18.0\"",
            "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "18"
        },
        "PD": {
            "wireCode": "PD",
            "wcDesc": "24 AWG, MIL-W-22759/33, White, Length: 24\"",
            "wcMenuDesc": "PD (Size: 24AWG, Spec: MIL-W-22759/33, Color: White, Length: 24.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "NWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "24.0\"",
            "wcLengthDesc": "24.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "24"
        },
        "PE": {
            "wireCode": "PE",
            "wcDesc": "24 AWG, MIL-W-22759/33, White, Length: 30\"",
            "wcMenuDesc": "PE (Size: 24AWG, Spec: MIL-W-22759/33, Color: White, Length: 30.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "30.0\"",
            "wcLengthDesc": "30.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "30"
        },
        "PF": {
            "wireCode": "PF",
            "wcDesc": "24 AWG, MIL-W-22759/33, White, Length: 36\"",
            "wcMenuDesc": "PF (Size: 24AWG, Spec: MIL-W-22759/33, Color: White, Length: 36.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "36.0\"",
            "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "36"
        },
        "PG": {
            "wireCode": "PG",
            "wcDesc": "24 AWG, MIL-W-22759/33, White, Length: 42\"",
            "wcMenuDesc": "PG (Size: 24AWG, Spec: MIL-W-22759/33, Color: White, Length: 42.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "42.0\"",
            "wcLengthDesc": "42.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "42"
        },
        "PH": {
            "wireCode": "PH",
            "wcDesc": "24 AWG, MIL-W-22759/33, White, Length: 48\"",
            "wcMenuDesc": "PH (Size: 24AWG, Spec: MIL-W-22759/33, Color: White, Length: 48.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "48.0\"",
            "wcLengthDesc": "48.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "48"
        },
        "PJ": {
            "wireCode": "PJ",
            "wcDesc": "24 AWG, MIL-W-22759/33, White, Length: 54\"",
            "wcMenuDesc": "PJ (Size: 24AWG, Spec: MIL-W-22759/33, Color: White, Length: 54.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "54.0\"",
            "wcLengthDesc": "54.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "54"
        },
        "PK": {
            "wireCode": "PK",
            "wcDesc": "24 AWG, MIL-W-22759/33, White, Length: 60\"",
            "wcMenuDesc": "PK (Size: 24AWG, Spec: MIL-W-22759/33, Color: White, Length: 60.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "60.0\"",
            "wcLengthDesc": "60.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "60"
        },
        "PL": {
            "wireCode": "PL",
            "wcDesc": "24 AWG, MIL-W-22759/33, White, Length: 66\"",
            "wcMenuDesc": "PL (Size: 24AWG, Spec: MIL-W-22759/33, Color: White, Length: 66.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "66.0\"",
            "wcLengthDesc": "66.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "66"
        },
        "PM": {
            "wireCode": "PM",
            "wcDesc": "24 AWG, MIL-W-22759/33, White, Length: 72\"",
            "wcMenuDesc": "PM (Size: 24AWG, Spec: MIL-W-22759/33, Color: White, Length: 72.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "72.0\"",
            "wcLengthDesc": "72.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "72"
        },
        "PN": {
            "wireCode": "PN",
            "wcDesc": "24 AWG, MIL-W-22759/33, White, Length: 84\"",
            "wcMenuDesc": "PN (Size: 24AWG, Spec: MIL-W-22759/33, Color: White, Length: 84.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "84.0\"",
            "wcLengthDesc": "84.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "84"
        },
        "PP": {
            "wireCode": "PP",
            "wcDesc": "24 AWG, MIL-W-22759/33, White, Length: 96\"",
            "wcMenuDesc": "PP (Size: 24AWG, Spec: MIL-W-22759/33, Color: White, Length: 96.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "NMIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "96.0\"",
            "wcLengthDesc": "96.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "96"
        },
        "PR": {
            "wireCode": "PR",
            "wcDesc": "24 AWG, MIL-W-22759/33, White, Length: 108\"",
            "wcMenuDesc": "PR (Size: 24AWG, Spec: MIL-W-22759/33, Color: White, Length: 108.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "108.0\"",
            "wcLengthDesc": "108.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "108"
        },
        "PS": {
            "wireCode": "PS",
            "wcDesc": "24 AWG, MIL-W-22759/33, White, Length: 120\"",
            "wcMenuDesc": "PS (Size: 24AWG, Spec: MIL-W-22759/33, Color: White, Length: 120.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "24 AWG",
            "wcWireSizeDesc": "24 AWG",
            "wcWireSizeMenu": "24",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "120.0\"",
            "wcLengthDesc": "120.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "120"
        },

        "RA": {
            "wireCode": "RA",
            "wcDesc": "26 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 6\"",
            "wcMenuDesc": "RA (Size: 26AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 6.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "6.0\"",
            "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "6"
        },
        "RB": {
            "wireCode": "RB",
            "wcDesc": "26 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 12\"",
            "wcMenuDesc": "RB (Size: 26AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 12.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "12.0\"",
            "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "12"
        },
        "RC": {
            "wireCode": "RC",
            "wcDesc": "26 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 18\"",
            "wcMenuDesc": "RC (Size: 26AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 18.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "18.0\"",
            "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "18"
        },
        "RD": {
            "wireCode": "RD",
            "wcDesc": "26 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 26\"",
            "wcMenuDesc": "RD (Size: 26AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 26.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "cWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "26.0\"",
            "wcLengthDesc": "26.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "26"
        },
        "RE": {
            "wireCode": "RE",
            "wcDesc": "26 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 30\"",
            "wcMenuDesc": "RE (Size: 26AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 30.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "30.0\"",
            "wcLengthDesc": "30.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "30"
        },
        "RF": {
            "wireCode": "RF",
            "wcDesc": "26 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 36\"",
            "wcMenuDesc": "RF (Size: 26AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 36.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "36.0\"",
            "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "36"
        },
        "RG": {
            "wireCode": "RG",
            "wcDesc": "26 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 42\"",
            "wcMenuDesc": "RG (Size: 26AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 42.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "42.0\"",
            "wcLengthDesc": "42.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "42"
        },
        "RH": {
            "wireCode": "RH",
            "wcDesc": "26 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 48\"",
            "wcMenuDesc": "RH (Size: 26AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 48.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "48.0\"",
            "wcLengthDesc": "48.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "48"
        },
        "RJ": {
            "wireCode": "RJ",
            "wcDesc": "26 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 54\"",
            "wcMenuDesc": "RJ (Size: 26AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 54.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "54.0\"",
            "wcLengthDesc": "54.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "54"
        },
        "RK": {
            "wireCode": "RK",
            "wcDesc": "26 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 60\"",
            "wcMenuDesc": "RK (Size: 26AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 60.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "60.0\"",
            "wcLengthDesc": "60.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "60"
        },
        "RL": {
            "wireCode": "RL",
            "wcDesc": "26 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 66\"",
            "wcMenuDesc": "RL (Size: 26AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 66.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "66.0\"",
            "wcLengthDesc": "66.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "66"
        },
        "RM": {
            "wireCode": "RM",
            "wcDesc": "26 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 72\"",
            "wcMenuDesc": "RM (Size: 26AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 72.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "72.0\"",
            "wcLengthDesc": "72.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "72"
        },
        "RN": {
            "wireCode": "RN",
            "wcDesc": "26 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 84\"",
            "wcMenuDesc": "RN (Size: 26AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 84.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "84.0\"",
            "wcLengthDesc": "84.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "84"
        },
        "RP": {
            "wireCode": "RP",
            "wcDesc": "26 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 96\"",
            "wcMenuDesc": "RP (Size: 26AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 96.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "NMIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "96.0\"",
            "wcLengthDesc": "96.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "96"
        },
        "RR": {
            "wireCode": "RR",
            "wcDesc": "26 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 108\"",
            "wcMenuDesc": "RR (Size: 26AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 108.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "108.0\"",
            "wcLengthDesc": "108.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "108"
        },
        "RS": {
            "wireCode": "RS",
            "wcDesc": "26 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 120\"",
            "wcMenuDesc": "RS (Size: 26AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 120.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "120.0\"",
            "wcLengthDesc": "120.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "120"
        },

        "SA": {
            "wireCode": "SA",
            "wcDesc": "26 AWG, MIL-W-22759/33, White, Length: 6\"",
            "wcMenuDesc": "SA (Size: 26AWG, Spec: MIL-W-22759/33, Color: White, Length: 6.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "6.0\"",
            "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "6"
        },
        "SB": {
            "wireCode": "SB",
            "wcDesc": "26 AWG, MIL-W-22759/33, White, Length: 12\"",
            "wcMenuDesc": "SB (Size: 26AWG, Spec: MIL-W-22759/33, Color: White, Length: 12.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "12.0\"",
            "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "12"
        },
        "SC": {
            "wireCode": "S",
            "wcDesc": "26 AWG, MIL-W-22759/33, White, Length: 18\"",
            "wcMenuDesc": "SC (Size: 26AWG, Spec: MIL-W-22759/33, Color: White, Length: 18.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "18.0\"",
            "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "18"
        },
        "SD": {
            "wireCode": "SD",
            "wcDesc": "26 AWG, MIL-W-22759/33, White, Length: 26\"",
            "wcMenuDesc": "SD (Size: 26AWG, Spec: MIL-W-22759/33, Color: White, Length: 26.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "cWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "26.0\"",
            "wcLengthDesc": "26.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "26"
        },
        "SE": {
            "wireCode": "SE",
            "wcDesc": "26 AWG, MIL-W-22759/33, White, Length: 30\"",
            "wcMenuDesc": "SE (Size: 26AWG, Spec: MIL-W-22759/33, Color: White, Length: 30.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "30.0\"",
            "wcLengthDesc": "30.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "30"
        },
        "SF": {
            "wireCode": "SF",
            "wcDesc": "26 AWG, MIL-W-22759/33, White, Length: 36\"",
            "wcMenuDesc": "SF (Size: 26AWG, Spec: MIL-W-22759/33, Color: White, Length: 36.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "36.0\"",
            "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "36"
        },
        "SG": {
            "wireCode": "SG",
            "wcDesc": "26 AWG, MIL-W-22759/33, White, Length: 42\"",
            "wcMenuDesc": "SG (Size: 26AWG, Spec: MIL-W-22759/33, Color: White, Length: 42.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "42.0\"",
            "wcLengthDesc": "42.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "42"
        },
        "SH": {
            "wireCode": "SH",
            "wcDesc": "26 AWG, MIL-W-22759/33, White, Length: 48\"",
            "wcMenuDesc": "SH (Size: 26AWG, Spec: MIL-W-22759/33, Color: White, Length: 48.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "48.0\"",
            "wcLengthDesc": "48.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "48"
        },
        "SJ": {
            "wireCode": "SJ",
            "wcDesc": "26 AWG, MIL-W-22759/33, White, Length: 54\"",
            "wcMenuDesc": "SJ (Size: 26AWG, Spec: MIL-W-22759/33, Color: White, Length: 54.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "54.0\"",
            "wcLengthDesc": "54.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "54"
        },
        "SK": {
            "wireCode": "SK",
            "wcDesc": "26 AWG, MIL-W-22759/33, White, Length: 60\"",
            "wcMenuDesc": "SK (Size: 26AWG, Spec: MIL-W-22759/33, Color: White, Length: 60.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "60.0\"",
            "wcLengthDesc": "60.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "60"
        },
        "SL": {
            "wireCode": "SL",
            "wcDesc": "26 AWG, MIL-W-22759/33, White, Length: 66\"",
            "wcMenuDesc": "SL (Size: 26AWG, Spec: MIL-W-22759/33, Color: White, Length: 66.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "66.0\"",
            "wcLengthDesc": "66.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "66"
        },
        "SM": {
            "wireCode": "SM",
            "wcDesc": "26 AWG, MIL-W-22759/33, White, Length: 72\"",
            "wcMenuDesc": "SM (Size: 26AWG, Spec: MIL-W-22759/33, Color: White, Length: 72.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "72.0\"",
            "wcLengthDesc": "72.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "72"
        },
        "SN": {
            "wireCode": "SN",
            "wcDesc": "26 AWG, MIL-W-22759/33, White, Length: 84\"",
            "wcMenuDesc": "SN (Size: 26AWG, Spec: MIL-W-22759/33, Color: White, Length: 84.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "84.0\"",
            "wcLengthDesc": "84.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "84"
        },
        "SP": {
            "wireCode": "SP",
            "wcDesc": "26 AWG, MIL-W-22759/33, White, Length: 96\"",
            "wcMenuDesc": "SP (Size: 26AWG, Spec: MIL-W-22759/33, Color: White, Length: 96.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "NMIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "96.0\"",
            "wcLengthDesc": "96.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "96"
        },
        "SR": {
            "wireCode": "SR",
            "wcDesc": "26 AWG, MIL-W-22759/33, White, Length: 108\"",
            "wcMenuDesc": "SR (Size: 26AWG, Spec: MIL-W-22759/33, Color: White, Length: 108.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "108.0\"",
            "wcLengthDesc": "108.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "108"
        },
        "SS": {
            "wireCode": "SS",
            "wcDesc": "26 AWG, MIL-W-22759/33, White, Length: 120\"",
            "wcMenuDesc": "SS (Size: 26AWG, Spec: MIL-W-22759/33, Color: White, Length: 120.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "26 AWG",
            "wcWireSizeDesc": "26 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "120.0\"",
            "wcLengthDesc": "120.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "120"
        },

        "TA": {
            "wireCode": "TA",
            "wcDesc": "28 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 6\"",
            "wcMenuDesc": "TA (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 6.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "6.0\"",
            "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "6"
        },
        "TB": {
            "wireCode": "TB",
            "wcDesc": "28 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 12\"",
            "wcMenuDesc": "TB (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 12.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "12.0\"",
            "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "12"
        },
        "TC": {
            "wireCode": "TC",
            "wcDesc": "28 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 18\"",
            "wcMenuDesc": "TC (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 18.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "18.0\"",
            "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "18"
        },
        "TD": {
            "wireCode": "TD",
            "wcDesc": "28 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 26\"",
            "wcMenuDesc": "TD (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 26.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "cWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "26.0\"",
            "wcLengthDesc": "26.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "26"
        },
        "TE": {
            "wireCode": "TE",
            "wcDesc": "28 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 30\"",
            "wcMenuDesc": "TE (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 30.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "30.0\"",
            "wcLengthDesc": "30.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "30"
        },
        "TF": {
            "wireCode": "TF",
            "wcDesc": "28 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 36\"",
            "wcMenuDesc": "TF (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 36.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "36.0\"",
            "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "36"
        },
        "TG": {
            "wireCode": "TG",
            "wcDesc": "28 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 42\"",
            "wcMenuDesc": "TG (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 42.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "42.0\"",
            "wcLengthDesc": "42.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "42"
        },
        "TH": {
            "wireCode": "TH",
            "wcDesc": "28 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 48\"",
            "wcMenuDesc": "TH (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 48.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "48.0\"",
            "wcLengthDesc": "48.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "48"
        },
        "TJ": {
            "wireCode": "TJ",
            "wcDesc": "28 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 54\"",
            "wcMenuDesc": "TJ (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 54.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "54.0\"",
            "wcLengthDesc": "54.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "54"
        },
        "TK": {
            "wireCode": "TK",
            "wcDesc": "28 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 60\"",
            "wcMenuDesc": "TK (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 60.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "60.0\"",
            "wcLengthDesc": "60.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "60"
        },
        "TL": {
            "wireCode": "TL",
            "wcDesc": "28 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 66\"",
            "wcMenuDesc": "TL (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 66.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "66.0\"",
            "wcLengthDesc": "66.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "66"
        },
        "TM": {
            "wireCode": "TM",
            "wcDesc": "28 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 72\"",
            "wcMenuDesc": "TM (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 72.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "72.0\"",
            "wcLengthDesc": "72.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "72"
        },
        "TN": {
            "wireCode": "TN",
            "wcDesc": "28 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 84\"",
            "wcMenuDesc": "TN (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 84.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "84.0\"",
            "wcLengthDesc": "84.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "84"
        },
        "TP": {
            "wireCode": "TP",
            "wcDesc": "28 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 96\"",
            "wcMenuDesc": "TP (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 96.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "NMIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "96.0\"",
            "wcLengthDesc": "96.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "96"
        },
        "TR": {
            "wireCode": "TR",
            "wcDesc": "28 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 108\"",
            "wcMenuDesc": "TR (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 108.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "108.0\"",
            "wcLengthDesc": "108.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "108"
        },
        "TS": {
            "wireCode": "TS",
            "wcDesc": "28 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 120\"",
            "wcMenuDesc": "TS (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 120.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "120.0\"",
            "wcLengthDesc": "120.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "120"
        },

        "UA": {
            "wireCode": "UA",
            "wcDesc": "28 AWG, MIL-W-22759/33, White, Length: 6\"",
            "wcMenuDesc": "UA (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 6.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "6.0\"",
            "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "6"
        },
        "UB": {
            "wireCode": "UB",
            "wcDesc": "28 AWG, MIL-W-22759/33, White, Length: 12\"",
            "wcMenuDesc": "UB (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 12.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "12.0\"",
            "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "12"
        },
        "UC": {
            "wireCode": "UC",
            "wcDesc": "28 AWG, MIL-W-22759/33, White, Length: 18\"",
            "wcMenuDesc": "UC (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 18.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "18.0\"",
            "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "18"
        },
        "UD": {
            "wireCode": "UD",
            "wcDesc": "28 AWG, MIL-W-22759/33, White, Length: 26\"",
            "wcMenuDesc": "UD (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 26.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "cWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "26.0\"",
            "wcLengthDesc": "26.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "26"
        },
        "UE": {
            "wireCode": "UE",
            "wcDesc": "28 AWG, MIL-W-22759/33, White, Length: 30\"",
            "wcMenuDesc": "UE (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 30.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "30.0\"",
            "wcLengthDesc": "30.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "30"
        },
        "UF": {
            "wireCode": "UF",
            "wcDesc": "28 AWG, MIL-W-22759/33, White, Length: 36\"",
            "wcMenuDesc": "UF (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 36.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "36.0\"",
            "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "36"
        },
        "UG": {
            "wireCode": "UG",
            "wcDesc": "28 AWG, MIL-W-22759/33, White, Length: 42\"",
            "wcMenuDesc": "UG (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 42.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "42.0\"",
            "wcLengthDesc": "42.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "42"
        },
        "UH": {
            "wireCode": "UH",
            "wcDesc": "28 AWG, MIL-W-22759/33, White, Length: 48\"",
            "wcMenuDesc": "UH (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 48.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "48.0\"",
            "wcLengthDesc": "48.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "48"
        },
        "UJ": {
            "wireCode": "UJ",
            "wcDesc": "28 AWG, MIL-W-22759/33, White, Length: 54\"",
            "wcMenuDesc": "UJ (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 54.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "54.0\"",
            "wcLengthDesc": "54.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "54"
        },
        "UK": {
            "wireCode": "UK",
            "wcDesc": "28 AWG, MIL-W-22759/33, White, Length: 60\"",
            "wcMenuDesc": "UK (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 60.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "60.0\"",
            "wcLengthDesc": "60.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "60"
        },
        "UL": {
            "wireCode": "UL",
            "wcDesc": "28 AWG, MIL-W-22759/33, White, Length: 66\"",
            "wcMenuDesc": "UL (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 66.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "66.0\"",
            "wcLengthDesc": "66.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "66"
        },
        "UM": {
            "wireCode": "UM",
            "wcDesc": "28 AWG, MIL-W-22759/33, White, Length: 72\"",
            "wcMenuDesc": "UM (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 72.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "72.0\"",
            "wcLengthDesc": "72.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "72"
        },
        "UN": {
            "wireCode": "UN",
            "wcDesc": "28 AWG, MIL-W-22759/33, White, Length: 84\"",
            "wcMenuDesc": "UN (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 84.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "84.0\"",
            "wcLengthDesc": "84.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "84"
        },
        "UP": {
            "wireCode": "UP",
            "wcDesc": "28 AWG, MIL-W-22759/33, White, Length: 96\"",
            "wcMenuDesc": "UP (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 96.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "NMIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "96.0\"",
            "wcLengthDesc": "96.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "96"
        },
        "UR": {
            "wireCode": "UR",
            "wcDesc": "28 AWG, MIL-W-22759/33, White, Length: 108\"",
            "wcMenuDesc": "UR (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 108.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "108.0\"",
            "wcLengthDesc": "108.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "108"
        },
        "US": {
            "wireCode": "US",
            "wcDesc": "28 AWG, MIL-W-22759/33, White, Length: 120\"",
            "wcMenuDesc": "US (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 120.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "28 AWG",
            "wcWireSizeDesc": "28 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "120.0\"",
            "wcLengthDesc": "120.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "120"
        },

        "VA": {
            "wireCode": "VA",
            "wcDesc": "30 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 6\"",
            "wcMenuDesc": "VA (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 6.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "6.0\"",
            "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "6"
        },
        "VB": {
            "wireCode": "VB",
            "wcDesc": "30 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 12\"",
            "wcMenuDesc": "VB (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 12.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "12.0\"",
            "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "12"
        },
        "VC": {
            "wireCode": "VC",
            "wcDesc": "30 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 18\"",
            "wcMenuDesc": "VC (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 18.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "18.0\"",
            "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "18"
        },
        "VD": {
            "wireCode": "VD",
            "wcDesc": "30 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 26\"",
            "wcMenuDesc": "VD (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 26.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "cWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "26.0\"",
            "wcLengthDesc": "26.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "26"
        },
        "VE": {
            "wireCode": "VE",
            "wcDesc": "30 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 30\"",
            "wcMenuDesc": "VE (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 30.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "30.0\"",
            "wcLengthDesc": "30.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "30"
        },
        "VF": {
            "wireCode": "VF",
            "wcDesc": "30 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 36\"",
            "wcMenuDesc": "VF (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 36.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "36.0\"",
            "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "36"
        },
        "VG": {
            "wireCode": "VG",
            "wcDesc": "30 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 42\"",
            "wcMenuDesc": "VG (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 42.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "42.0\"",
            "wcLengthDesc": "42.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "42"
        },
        "VH": {
            "wireCode": "VH",
            "wcDesc": "30 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 48\"",
            "wcMenuDesc": "VH (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 48.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "48.0\"",
            "wcLengthDesc": "48.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "48"
        },
        "VJ": {
            "wireCode": "VJ",
            "wcDesc": "30 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 54\"",
            "wcMenuDesc": "VJ (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 54.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "54.0\"",
            "wcLengthDesc": "54.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "54"
        },
        "VK": {
            "wireCode": "VK",
            "wcDesc": "30 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 60\"",
            "wcMenuDesc": "VK (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 60.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "60.0\"",
            "wcLengthDesc": "60.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "60"
        },
        "VL": {
            "wireCode": "VL",
            "wcDesc": "30 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 66\"",
            "wcMenuDesc": "VL (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 66.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "66.0\"",
            "wcLengthDesc": "66.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "66"
        },
        "VM": {
            "wireCode": "VM",
            "wcDesc": "30 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 72\"",
            "wcMenuDesc": "VM (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 72.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "72.0\"",
            "wcLengthDesc": "72.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "72"
        },
        "VN": {
            "wireCode": "VN",
            "wcDesc": "30 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 84\"",
            "wcMenuDesc": "VN (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 84.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "84.0\"",
            "wcLengthDesc": "84.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "84"
        },
        "VP": {
            "wireCode": "VP",
            "wcDesc": "30 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 96\"",
            "wcMenuDesc": "VP (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 96.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "NMIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "96.0\"",
            "wcLengthDesc": "96.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "96"
        },
        "VR": {
            "wireCode": "VR",
            "wcDesc": "30 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 108\"",
            "wcMenuDesc": "VR (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 108.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "108.0\"",
            "wcLengthDesc": "108.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "108"
        },
        "VS": {
            "wireCode": "VS",
            "wcDesc": "30 AWG, MIL-W-22759/33, Ten Colors Repeating, Length: 120\"",
            "wcMenuDesc": "VS (Size: 28AWG, Spec: MIL-W-22759/33, Color: Ten Colors Repeating, Length: 120.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "Ten Colors Repeating",
            "wcColorDesc": "Beginning at Position 1: Black, Brown, Red, Orange, Yellow, Green, Blue, Violet, Grey, White",
            "wcColorMenu": "COLOR",
            "wcLength": "120.0\"",
            "wcLengthDesc": "120.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "120"
        },

        "WA": {
            "wireCode": "WA",
            "wcDesc": "30 AWG, MIL-W-22759/33, White, Length: 6\"",
            "wcMenuDesc": "WA (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 6.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "6.0\"",
            "wcLengthDesc": "6.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "6"
        },
        "WB": {
            "wireCode": "WB",
            "wcDesc": "30 AWG, MIL-W-22759/33, White, Length: 12\"",
            "wcMenuDesc": "WB (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 12.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "12.0\"",
            "wcLengthDesc": "12.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "12"
        },
        "WC": {
            "wireCode": "KC",
            "wcDesc": "30 AWG, MIL-W-22759/33, White, Length: 18\"",
            "wcMenuDesc": "WC (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 18.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "18.0\"",
            "wcLengthDesc": "18.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "18"
        },
        "WD": {
            "wireCode": "WD",
            "wcDesc": "30 AWG, MIL-W-22759/33, White, Length: 26\"",
            "wcMenuDesc": "WD (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 26.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "cWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "26.0\"",
            "wcLengthDesc": "26.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "26"
        },
        "WE": {
            "wireCode": "WE",
            "wcDesc": "30 AWG, MIL-W-22759/33, White, Length: 30\"",
            "wcMenuDesc": "WE (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 30.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "30.0\"",
            "wcLengthDesc": "30.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "30"
        },
        "WF": {
            "wireCode": "WF",
            "wcDesc": "30 AWG, MIL-W-22759/33, White, Length: 36\"",
            "wcMenuDesc": "WF (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 36.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "36.0\"",
            "wcLengthDesc": "36.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "36"
        },
        "WG": {
            "wireCode": "WG",
            "wcDesc": "30 AWG, MIL-W-22759/33, White, Length: 42\"",
            "wcMenuDesc": "WG (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 42.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "42.0\"",
            "wcLengthDesc": "42.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "42"
        },
        "WH": {
            "wireCode": "WH",
            "wcDesc": "30 AWG, MIL-W-22759/33, White, Length: 48\"",
            "wcMenuDesc": "WH (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 48.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "48.0\"",
            "wcLengthDesc": "48.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "48"
        },
        "WJ": {
            "wireCode": "WJ",
            "wcDesc": "30 AWG, MIL-W-22759/33, White, Length: 54\"",
            "wcMenuDesc": "WJ (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 54.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "54.0\"",
            "wcLengthDesc": "54.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "54"
        },
        "WK": {
            "wireCode": "WK",
            "wcDesc": "30 AWG, MIL-W-22759/33, White, Length: 60\"",
            "wcMenuDesc": "WK (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 60.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "60.0\"",
            "wcLengthDesc": "60.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "60"
        },
        "WL": {
            "wireCode": "WL",
            "wcDesc": "30 AWG, MIL-W-22759/33, White, Length: 66\"",
            "wcMenuDesc": "WL (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 66.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "66.0\"",
            "wcLengthDesc": "66.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "66"
        },
        "WM": {
            "wireCode": "WM",
            "wcDesc": "30 AWG, MIL-W-22759/33, White, Length: 72\"",
            "wcMenuDesc": "WM (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 72.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "72.0\"",
            "wcLengthDesc": "72.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "72"
        },
        "WN": {
            "wireCode": "WN",
            "wcDesc": "30 AWG, MIL-W-22759/33, White, Length: 84\"",
            "wcMenuDesc": "WN (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 84.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "84.0\"",
            "wcLengthDesc": "84.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "84"
        },
        "WP": {
            "wireCode": "WP",
            "wcDesc": "30 AWG, MIL-W-22759/33, White, Length: 96\"",
            "wcMenuDesc": "WP (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 96.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "NMIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "96.0\"",
            "wcLengthDesc": "96.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "96"
        },
        "WR": {
            "wireCode": "WR",
            "wcDesc": "30 AWG, MIL-W-22759/33, White, Length: 108\"",
            "wcMenuDesc": "WR (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 108.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "108.0\"",
            "wcLengthDesc": "108.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "108"
        },
        "WS": {
            "wireCode": "WS",
            "wcDesc": "30 AWG, MIL-W-22759/33, White, Length: 120\"",
            "wcMenuDesc": "WS (Size: 28AWG, Spec: MIL-W-22759/33, Color: White, Length: 120.0\")",
            "wcSpec": "MIL-W-22759/33",
            "wcSpecDesc": "MIL-W-22759/33",
            "wcSpecMenu": "MIL-W-22759/33",
            "wcWireSize": "30 AWG",
            "wcWireSizeDesc": "30 AWG",
            "wcWireSizeMenu": "26",
            "wcColor": "White",
            "wcColorDesc": "White",
            "wcColorMenu": "WHITE",
            "wcLength": "120.0\"",
            "wcLengthDesc": "120.0\" (+1.0\"/-0.0\")",
            "wcLengthMenu": "120"
        },

    }
}

